import { Post } from "services/apiService";
import {
  GET_MANUAL_ORDER_AUDIT_ERROR_DOWNLOAD,
  GET_MANUAL_ORDER_AUDIT_REQUEST_DOWNLOAD,
  GET_MANUAL_ORDER_AUDIT_SUCCESS_DOWNLOAD,
} from "./action-type";
import { BASE_URL } from "services/CONSTANTS";

export const downloadManualOrdersAudit = (params) => async (dispatch) => {
  // Extract API key, offset, and reqBody from the params (payload)
  const { apiKey, offset, limit, reqBody } = params;

  const apiUrl = `${BASE_URL}orders/@fetchorders?apikey=${apiKey}&offset=${offset}&limit=${limit}`;

  // Dispatch the request action to indicate that the fetch process is starting
  dispatch({ type: GET_MANUAL_ORDER_AUDIT_REQUEST_DOWNLOAD });

  // Perform the POST request to the API using the custom Post function
  Post({
    url: apiUrl, // The constructed URL
    params: reqBody, // The request body (payload)
    config: {}, // Default configuration for axios (can be extended if needed)
  })
    .then((response) => {
      // Success - Dispatch the data
      if (response.status === 200) {
        dispatch({
          type: GET_MANUAL_ORDER_AUDIT_SUCCESS_DOWNLOAD,
          payload: response.data.orders, // Ensure 'orders' is the correct key in response data
        });
      } else {
        // Failure - Dispatch error
        dispatch({
          type: GET_MANUAL_ORDER_AUDIT_ERROR_DOWNLOAD,
          payload:
            response.data.errorMessage ||
            "Error occurred while fetching orders.",
        });
      }
    })
    .catch((err) => {
      // Handle network or server errors
      dispatch({
        type: GET_MANUAL_ORDER_AUDIT_ERROR_DOWNLOAD,
        payload: err.message || "An error occurred while fetching data.",
      });
    });
};
